// import './agenda.css'
import { useParams } from "react-router-dom";
import ItemAgenda from "../../components/ItemAgenda/ItemAgenda";
import "./agendaDetails.css";

const AgendaDetails = ({ events }) => {
	const { id } = useParams();
	const event = events.find((event) => event.id === +id);

	return (
		<div className="container agendaDetailContainer">
			{event && event.length !== 0 && (
				<div className="agendaContainer ">
					<div className="titleAgenda">Agenda</div>
					<ItemAgenda event={event} />;
				</div>
			)}
		</div>
	);
};

export default AgendaDetails;
